import { useMutation } from '@apollo/client'
import { Box, FormControl, Radio, RadioGroup, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Drawer } from 'src/components'
import { LanguageSelectContainer, LanguageOption } from './InfoResident.styles'
import { LANGUAGE_CODES, languageCodeToName } from 'src/pages/Inbox/helpers'
import { Maybe } from 'src/@types/graphql'
import Button from 'src/components/Button/Button'
import { UPDATE_PERSON_LANGUAGE } from '../../data/mutations'
import { useState } from 'react'

interface Props {
  onClose: () => void
  open: boolean
  currentLanguageCode?: Maybe<string>
  residentId: number
  refetch: () => Promise<any>
}

const LanguageSelect = ({
  open,
  onClose,
  currentLanguageCode,
  residentId,
  refetch,
}: Props) => {
  const theme = useTheme()
  const [selectedLanguage, setSelectedLanguage] = useState(
    () => currentLanguageCode || 'en',
  )
  const [updateLanguage, { loading }] = useMutation(UPDATE_PERSON_LANGUAGE)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedLanguage((event.target as HTMLInputElement).value)
  }
  const onSave = async () => {
    await updateLanguage({
      variables: {
        payload: { id: residentId, language_code: selectedLanguage },
      },
      onCompleted: () => {
        refetch()
        onClose()
      },
    })
  }
  return (
    <>
      <Drawer
        onClose={onClose}
        onOpen={() => undefined}
        open={open}
        anchor="right"
        title={
          <Typography fontWeight={500} fontSize="1.25rem" paddingLeft="1rem">
            Change Language
          </Typography>
        }
      >
        <LanguageSelectContainer>
          <FormControl fullWidth>
            <RadioGroup
              aria-labelledby="language-selection-options-list"
              value={selectedLanguage}
              name="language-selection-group"
              onChange={handleChange}
            >
              {LANGUAGE_CODES.map((code: string) => (
                <LanguageOption
                  value={code}
                  control={<Radio />}
                  label={languageCodeToName(code)}
                  labelPlacement="start"
                  key={code}
                />
              ))}
            </RadioGroup>
          </FormControl>

          <Box mt="2.25rem" ml="0.5rem" display="flex" columnGap="0.5rem">
            <Button
              variant="text"
              textColor={theme.palette.text.primary}
              onClick={onClose}
            >
              <Typography fontWeight="500">Cancel</Typography>
            </Button>
            <Button onClick={onSave} isLoading={loading}>
              Save
            </Button>
          </Box>
        </LanguageSelectContainer>
      </Drawer>
    </>
  )
}

export default LanguageSelect
